import { render, staticRenderFns } from "./cdata_tab_component.vue?vue&type=template&id=0c81ebb1&scoped=true&"
import script from "./cdata_tab_component.vue?vue&type=script&lang=js&"
export * from "./cdata_tab_component.vue?vue&type=script&lang=js&"
import style0 from "./cdata_tab_component.vue?vue&type=style&index=0&id=0c81ebb1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c81ebb1",
  null
  
)

export default component.exports